export const prepareUrlParamsForFilterProducts = (
  pageContext,
  keyWords,
  filterList,
  page,
  sortBy,
  shopId,
  categoryId = null
) => {
  let params = "";
  let separator = "?";
  if (keyWords) {
    params += `${separator}query=${keyWords}`;
    separator = "&";
  }
  if (filterList) {
    let filterQuery = "";
    const groupedFilterList = {};
    filterList.map((filter) => {
      const filterName = filter.code;
      if (!groupedFilterList[filterName]) {
        groupedFilterList[filterName] = [];
      }
      groupedFilterList[filterName].push(filter.value);
    });
    for (const groupedFilter in groupedFilterList) {
      groupedFilterList[groupedFilter].map((filter, index) => {
        filterQuery += `${separator}filters[${groupedFilter}][${index}]=${filter}`;
        separator = "&";
      });
    }
    params += filterQuery;
  }
  // Sort
  if (sortBy) {
    params += `${separator}sort-by=${sortBy}`;
    separator = "&";
  }
  // PageIndex
  if (page) {
    params += `${separator}page=${page}`;
    separator = "&";
  }
  if (pageContext === "DP") {
    return `/api/magasins/${shopId}/navigation-content/C-${categoryId}${params}`;
  } else {
    return `/api/magasins/${shopId}/recherche${params}`;
  }
};

export const prepareParamsForFilterProducts = (params) => {
  // Filters
  const queryFilters = [];
  if (params.currentFiltersValue && params.currentFiltersValue.length) {
    if (params.filters) {
      for (const appliedFilter of params.filters) {
        if (appliedFilter.checked) {
          queryFilters.push({
            code: appliedFilter.code,
            value: appliedFilter.value
          });
        } else {
          const index = params.currentFiltersValue.findIndex(
            (filter) => filter.valeur === appliedFilter.value
          );
          params.currentFiltersValue.splice(index, 1);
        }
      }

      delete params.filters;
    }
    params.currentFiltersValue.map((filter, index) => {
      queryFilters.push({
        code: filter.code,
        value: filter.valeur
      });
    });
    params.filterList = queryFilters;
  } else if (params.filters) {
    for (const appliedFilter of params.filters) {
      queryFilters.push({
        code: appliedFilter.code,
        value: appliedFilter.value
      });
    }
    params.filterList = queryFilters;
  }
  delete params.currentFiltersValue;
  return params;
};

export const getQueryParamsFromUrl = (params, query) => {
  const parameters = {};
  if (params.filtersQuery && params.filtersQuery !== undefined) {
    const filterList = [];
    const filters = params.filtersQuery;
    filters.map((filter, index) => {
      const splitedFilter = filter.split("~");
      filterList.push({
        code: splitedFilter[0],
        value: cleanFilter(filter)
      });
    });
    parameters.filterList = filterList;
  }
  if (query.sortby) {
    parameters.sortBy = query.sortby;
  }
  if (query.pageindex) {
    parameters.page = query.pageindex;
  }
  if (query.keywords) {
    parameters.keyWords = query.keywords;
  }
  return parameters;
};

export const searchPrepareParamsForFilterProducts = (params) => {
  // Filters
  const queryFilters = [];
  if (params.currentFiltersValue && params.currentFiltersValue.length) {
    if (params.filters) {
      for (const appliedFilter of params.filters) {
        if (appliedFilter.checked) {
          queryFilters.push({
            code: appliedFilter.code,
            value: appliedFilter.value
          });
        } else {
          const index = params.currentFiltersValue.findIndex(
            (filter) => filter.valeur === appliedFilter.value
          );
          params.currentFiltersValue.splice(index, 1);
        }
      }

      delete params.filters;
    }
    params.currentFiltersValue.map((filter, index) => {
      queryFilters.push({
        code: filter.code,
        value: filter.valeur
      });
    });
    params.filterList = queryFilters;
  } else if (params.filters) {
    for (const appliedFilter of params.filters) {
      queryFilters.push({
        code: appliedFilter.code,
        value: appliedFilter.value
      });
    }
    params.filterList = queryFilters;
  }
  delete params.currentFiltersValue;
  return params;
};

export const searchgetQueryParamsFromUrl = (params, query) => {
  const parameters = {};
  if (params.filtersQuery && params.filtersQuery !== undefined) {
    const filterList = [];
    const filters = params.filtersQuery;
    filters.map((filter, index) => {
      const decoded = decodeURIComponent(filter);
      const splitedFilter = decoded.split("=");
      const code = splitedFilter[0].split(".");
      filterList.push({
        code: code[1],
        value: cleanFilter(decoded)
      });
    });
    parameters.filterList = filterList;
  }
  if (query.sortby) {
    parameters.sortBy = query.sortby;
  }
  if (query.pageindex) {
    parameters.page = query.pageindex;
  }
  if (query.keywords) {
    parameters.keyWords = query.keywords;
  }
  return parameters;
};

export const filterSlug = (slug) => {
  const filteredSlug = decodeURI(slug.split("?")[0]);
  // Bug de nuxt, obligation de vérifier les virgules
  return filteredSlug.replace(/%2[cC]/g, ",").toLowerCase();
};

const cleanFilter = (filter) => {
  return encodeURIComponent(filter);
};
